import axios from "axios";
import storage from "../helpers/storage";

const { REACT_APP_API_HOST } = process.env;

const api = axios.create({
  baseURL: REACT_APP_API_HOST,
});

api.interceptors.response.use(
  function (response) {
    return response;
  },
  function (error) {
    console.log(error);
    if (error.response.status === 401) {
      if (error.response.data.detail !== "Incorrect username or password") {
        storage.remove("token");
        document.location.reload(true);
      }
    } else {
      return Promise.reject(error);
    }
  }
);
export default api;
